import {
  Disclaimer,
  Div,
  P,
  Pill,
  TooltipWrapper,
  convert24HourTo12Hour,
  lightTheme,
  renderDayOfWeekString,
} from '@vgrubs/components';
import { MenuAvailabilityV2Response } from 'components/src/types/menu.types';

const renderScheduleTooltip = (schedule: MenuAvailabilityV2Response) => {
  if (!schedule.hours?.length) return false;
  return schedule.hours
    .map(
      (hour) =>
        `${renderDayOfWeekString(hour.day)}: ${convert24HourTo12Hour(
          hour.startTime
        )} - ${convert24HourTo12Hour(hour.endTime)}`
    )
    .join('<br/>');
};

/**
 * A category's custom schedules as pills, with the hours in a tooltip.
 * `inverted` is for a primary-colored background (an expanded category on the
 * Items tab).
 */
export const CategorySchedulePills = ({
  schedules,
  inverted,
}: {
  schedules?: MenuAvailabilityV2Response[];
  inverted?: boolean;
}) => {
  if (!schedules?.length) return null;

  return (
    <Div
      $flex
      $gap="8px"
      $wrap
      $alignCenter
      $mt="4"
      // Hovering a pill shows its hours - clicking it must not open or
      // toggle the row underneath.
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <P $mb="0" $color={inverted ? lightTheme.white : lightTheme.lightGray}>
        Custom Schedules:
      </P>
      {schedules.map((schedule) => (
        <TooltipWrapper
          key={schedule.id}
          tooltip={renderScheduleTooltip(schedule)}
        >
          <Pill
            $background={inverted ? lightTheme.white : lightTheme.gray}
            $minWidth="auto"
            $minWidthSM="auto"
          >
            <Disclaimer
              $m="0"
              $color={inverted ? lightTheme.primary : lightTheme.darkGray}
            >
              {schedule.name}
            </Disclaimer>
          </Pill>
        </TooltipWrapper>
      ))}
    </Div>
  );
};
